// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"BasicFormDateInput_inputContainer__aeL2W","input":"BasicFormDateInput_input__14W_7"};